import axios from "axios";
import { jwtDecode } from "jwt-decode";

export const refreshTokenService = async (
    refreshToken: string
): Promise<{ accessToken: string; refreshToken: string }> => {
    const response = await axios.post(
        `${process.env.REACT_APP_JT_API}/v2/auth/refresh`,
        { refreshToken },
        {
            headers: {
                "Content-Type": "application/json",
            },
        }
    );

    if (response.status !== 200) {
        throw new Error("Impossible de rafraîchir le token");
    }
    
    return response.data;
};

export const verifyTokenService = async (accessToken: string) => {
    const response = await axios.post(
        `${process.env.REACT_APP_JT_API}/v2/auth/verify-token`,
        {},
        {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
    return response.data;
};

export const loginService = async (email: string, password: string) => {
    const response = await axios.post(
        `${process.env.REACT_APP_JT_API}/v2/auth/login`,
        { email, password }
    );
    return response.data;
};

export const requestPasswordReset = async (email: string) => {
    const response = await axios.post(
        `${process.env.REACT_APP_JT_API}/v2/auth/forgot-password`,
        { email }
    );
    return response.data;
};

export const resetPassword = async (
    token: string,
    newPassword: string,
    confirmPassword: string
) => {
    try {
        const decodedToken = jwtDecode<{ id: string }>(token);
        const response = await axios.post(
            `${process.env.REACT_APP_JT_API}/v2/auth/reset-password`,
            {
                token,
                id: decodedToken.id,
                newPassword,
                confirmPassword,
            }
        );
        return response.data;
    } catch (error: any) {
        const data = error?.response?.data;
        if (data?.errors && Array.isArray(data.errors)) {
            const formatted = new Error("Validation failed");
            (formatted as any).errors = data.errors.map((item: any) => ({
                field: item.field || "unknown",
                message: item.message || "Erreur inconnue.",
            }));
            throw formatted;
        }
        throw new Error(data?.message || "Une erreur s'est produite.");
    }
};